/* Disclosure behavior for the theme's native navigation controls. */
(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-jcs-dropdown]').forEach(item => {
      if (item.dataset.jcsInitialized) return;
      const toggle = item.querySelector('[data-header-submenu-toggle]');
      const panel = toggle && document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;
      item.dataset.jcsInitialized = 'true';
      function setOpen(open) {
        item.classList.toggle('is-opened', open);
        toggle.setAttribute('aria-expanded', String(open));
        panel.inert = !open;
      }
      setOpen(false);
      toggle.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });
      item.addEventListener('mouseenter', () => setOpen(true));
      item.addEventListener('mouseleave', () => {
        if (!item.contains(document.activeElement)) setOpen(false);
      });
      item.addEventListener('focusout', event => {
        if (!item.contains(event.relatedTarget)) setOpen(false);
      });
      item.addEventListener('keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault();
          setOpen(false);
          toggle.focus();
        } else if (event.key === 'ArrowDown' && (event.target === toggle || event.target.parentElement === item)) {
          event.preventDefault();
          setOpen(true);
          panel.querySelector('a[href], button')?.focus();
        }
      });
      document.addEventListener('click', event => {
        if (!item.contains(event.target)) setOpen(false);
      });
    });
    root.querySelectorAll('[data-mobile-submenu-toggle]').forEach(toggle => {
      if (toggle.dataset.jcsInitialized) return;
      const panel = document.getElementById(toggle.getAttribute('aria-controls'));
      const checkbox = toggle.closest('.submenu__label')?.previousElementSibling;
      if (!panel || !checkbox || checkbox.type !== 'checkbox') return;
      toggle.dataset.jcsInitialized = 'true';
      function sync() {
        panel.inert = !checkbox.checked;
        toggle.setAttribute('aria-expanded', String(checkbox.checked));
      }
      toggle.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        checkbox.checked = !checkbox.checked;
        sync();
      });
      checkbox.addEventListener('change', sync);
      sync();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
